import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  TableContainer, 
  Paper, 
  Pagination, 
  Stack, 
  Box, 
  Typography,
  Button,
  Toolbar,

  CircularProgress
} from '@mui/material';
import TableCombined from './Table';
import AllDataUser from './AllDataUser';
import { fetchRegisteredUsers, setCurrentPage } from '../../../../Reducer/adminSlice';
import AnchorTemporaryDrawer from '../addUser/AnchorTemporaryDrawer';
import axios from 'axios';
import { toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import FilterListIcon from '@mui/icons-material/FilterList';

const RegisterUserList = () => {
  const dispatch = useDispatch();
  const { registeredUsers, status, error, totalPages, currentPage } = useSelector(
    (state) => state.registerUser
  );

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filters, setFilters] = useState({ username: '', createdAt: null, sort: 'DESC' });
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    dispatch(fetchRegisteredUsers({ page: currentPage, limit: 10, ...filters }));
  }, [dispatch, currentPage, filters]);

  const handlePageChange = (event, page) => {
    dispatch(setCurrentPage(page));
  };

  const applyFilters = () => {
    dispatch(fetchRegisteredUsers({ page: 1, limit: 10, ...filters }));
  };

  const clearFilters = () => {
    setFilters({ name: '', username: '', createdAt: null, sort: 'DESC' });
    dispatch(fetchRegisteredUsers({ page: 1, limit: 10, name: '', username: '', createdAt: null, sort: 'DESC' }));
  };

  const handleDeleteUser = async(userId) => {
    const deleteConfirmed = window.confirm('Are you sure you want to delete this user?');
    if (!deleteConfirmed) return;
    const deleteUser = await axios.delete(`/api/v1/delete-subscribe-user/${userId}`);
    if (deleteUser.status === 200) {
      toast.success('User deleted successfully');
      dispatch(fetchRegisteredUsers({ page: currentPage, limit: 10, ...filters }));
    } else {
      alert('Failed to delete user');
    }
  };

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      <Paper elevation={3} sx={{ p: { xs: 1.5, sm: 2 }, mb: 3 }}>
        <Toolbar
          sx={{ 
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 2,
            p: '0 !important'
          }}
        >
          <Typography variant="h5" component="div" color='#1976d2' fontWeight = "400" sx={{ fontWeight: 'bold' }}>
            Registered Users
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setShowFilters(!showFilters)}
              sx={{ textTransform: 'none' }}
              fullWidth
            >
              {showFilters ? 'Hide Filters' : 'Show Filters'}
            </Button>

            

            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => setDrawerOpen(true)}
              sx={{ textTransform: 'none' }}
              fullWidth
            >
              Add User
            </Button>
          </Stack>
        </Toolbar>

        {showFilters && (
          <Box sx={{ mt: 2, p: 2, backgroundColor: 'background.paper', borderRadius: 1 }}>
            <AllDataUser
              filters={filters}
              setFilters={setFilters}
              applyFilters={applyFilters}
              clearFilters={clearFilters}
            />
          </Box>
        )}
      </Paper>

      {status === 'loading' ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error" align="center" sx={{ mt: 2 }}>
          Error: {error}
        </Typography>
      ) : (
        <>
          <TableContainer component={Paper} elevation={3} sx={{ width: '100%', overflowX: 'auto' }}>
            <TableCombined 
              aria-label="register user list" 
              data={registeredUsers} 
              handleDeleteUser={handleDeleteUser} 
            />
          </TableContainer>

          {totalPages > 1 && (
            <Stack spacing={2} sx={{ mt: 3, alignItems: 'center' }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                shape="rounded"
                size="large"
              />
            </Stack>
          )}
        </>
      )}

      <AnchorTemporaryDrawer open={drawerOpen} toggleDrawer={() => setDrawerOpen(false)} />
    </Box>
  );
};

export default RegisterUserList;